import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  AddressBean,
  RestReadRequest,
  RestRoyaltyClientListRequest,
  RoyaltyClientBean,
  RoyaltyClientSearchCriteria,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class RoyaltyClientListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {
      royaltyClient_list: this.props.royaltyClient_list,
      editRoyaltyClient: this.props.editRoyaltyClient,
      pageList: new PageListBean(),
      criteria: new RoyaltyClientSearchCriteria(),
      royaltyClientData: this.props.royaltyClientData,
      show_text: false,
    };
  }
  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    e.preventDefault();
    this.props.onChange(e);
  };
  editRoyaltyClient = (e, val, rowdata) => {
    if (e.detail === 1) this.props.editRoyaltyClient(val, rowdata);
  };
  deleteRoyaltyClient = (e, rowData) => {
    if (e.detail === 1) this.props.deleteRoyaltyClient(rowData);
  };
  buttonCancelClickCallback = () => {
    this.props.buttonCancelClickCallback();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  clickGoButton = (e) => {
    if (e.detail === 1) this.props.clickGoButton();
  };
  render() {
    let royaltyClient_list = this.props.royaltyClient_list;
    let royaltyClientData = this.props.royaltyClientData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">Royalty Client</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                ref={this.listFormCodeRef}
                onChange={this.props.onChange}
                value={royaltyClientData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.clickGoButton(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {royaltyClient_list != null ? (
              <tbody>
                {royaltyClient_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editRoyaltyClient(e, Info.code, Info)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.deleteRoyaltyClient(e, Info.code)}
                      >
                        {<DeleteIcon />}
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {royaltyClient_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class RoyaltyClientEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {
    this.codeRef.current.focus();
  }
  componentDidUpdate() {}
  onChange = (e) => {
    this.props.onChange(e);
  };
  onAddressChange = (e) => {
    this.props.onAddressChange(e);
  };
  saveRoyaltyClient = (e) => {
    this.props.saveRoyaltyClient(this.state.royaltyClientData);
  };
  closeRoyaltyClientEntryForm() {
    this.props.closeRoyaltyClientEntryForm();
  }
  render() {
    let royaltyClientData = this.props.royaltyClientData;
    let addressData = this.props.addressData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              {" "}
              <FormLabel>Company Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="companyCode"
                type="text"
                placeholder="Enter CompanyCode"
                onChange={this.onChange}
                value={royaltyClientData.companyCode}
                disabled="true"
              />{" "}
            </Col>
            <Col sm="2">
              {" "}
              <FormLabel>Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="code"
                type="text"
                placeholder="Enter RoyaltyClientCode"
                onChange={this.onChange}
                value={royaltyClientData.code}
                style={{ "text-transform": "uppercase" }}
                disabled={isDisableFields}
                ref={this.codeRef}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="2">
              <FormLabel> Name</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="description"
                type="text"
                placeholder="Enter Name"
                onChange={this.onChange}
                value={royaltyClientData.description}
                style={{ "text-transform": "capitalize" }}
                isMandatory={true}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Active</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isActive"
                onChange={this.onChange}
                checked={royaltyClientData.isActive}
              />
            </Col>
          </Row>

          <br />
        </div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel className="address">Address</FormLabel>
            </Col>
          </Row>
          <hr class="row_border"></hr>
          <Row>
            <Col sm="2">
              <FormLabel>Address1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address1"
                onChange={this.onAddressChange}
                value={addressData.address1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.props.onCountryChange}
                name="country"
                placeholder="country"
                valuePropery="code"
                descriptionProperty="description"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.props.countryLookupHandler}
                enterKeyEventHandler={this.props.countryCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
              />
            </Col>
            <Col sm="2">
              <FormLabel>Phone#2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone2"
                type="text"
                placeholder="Enter Phone2"
                onChange={this.onAddressChange}
                value={addressData.phone2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>Address2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Mobile#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter MobileNo"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onCityChange}
                name="city"
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.props.cityLookupHandler}
                enterKeyEventHandler={this.props.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.props.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Contact Person</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onStateChange}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.props.stateLookupHandler}
                enterKeyEventHandler={this.props.stateEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.props.displayAutoCompleteStateList
                }
                showAutoCompleteList={this.props.showAutoCompleteStateList}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Phone#1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter PhoneNo1"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="2">
              <FormLabel>Website</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="website"
                type="text"
                placeholder="Enter Website"
                onChange={this.onAddressChange}
                value={addressData.website}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>

          <br />
        </div>
        <div>
          <hr class="row_border"></hr>
          <Row>
            <Col sm="2">
              <FormLabel>Remarks</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="remarks"
                type="text"
                placeholder="Enter remarks"
                onChange={this.onChange}
                value={royaltyClientData.remarks}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

class RoyaltyClientList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      royaltyClient_list: [],
      response: {},
      pageTitle: "Royalty Client",
      royaltyClientData: new RoyaltyClientBean(),
      pageList: new PageListBean(),
      criteria: new RoyaltyClientSearchCriteria(),
      addressData: new AddressBean(),
      companyCode: "",
      countries: [],
      cities: [],
      states: [],

      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isRoyaltyClientListFormOpen: true,
      isRoyaltyClientEntryFormOpen: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isEntryFormOpen: false,
      isDisableFields: false,
      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      cityLookupHandler: null,
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      isShowExitButton: true,
      order: "asc",
      sortField: "",
    };
    this.moduleCaption = "Royalty Client";
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const countries = new Array();
    if (!isEmptyArray(attribute_cache.countries))
      countries.push(...attribute_cache.countries);
    this.state.countries = countries;

    const states = new Array();
    if (!isEmptyArray(attribute_cache.states))
      states.push(...attribute_cache.states);
    this.state.states = states;

    const cities = new Array();
    if (!isEmptyArray(attribute_cache.cities))
      cities.push(...attribute_cache.cities);
    this.state.cities = cities;

    this.loadPage(1);
    this.cleardata();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };

  clickGoButton = () => {
    let royaltyClientCode = this.state.royaltyClientData;
    this.editRoyaltyClient(royaltyClientCode.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  cleardata = () => {
    let royaltyClientData = new RoyaltyClientBean();
    royaltyClientData.companyCode = this.companyCode;
    let addressData = new AddressBean();
    addressData.companyCode = this.companyCode;
    this.setState({
      royaltyClientData: royaltyClientData,
      addressData: addressData,
    });
  };
  saveRoyaltyClientResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeRoyaltyClientEntryForm();
    } else {
      this.handleresponse(response.data);
    }
  };

  saveRoyaltyClient = (royaltyClientData) => {
    if (royaltyClientData.isFetched == true) {
      if (SecurityAccessManager.RoyaltyClientMaintenanceEdit_IsAccessible()) {
        MasterService.updateRoyaltyClient(
          royaltyClientData,
          this.saveRoyaltyClientResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.RoyaltyClientMaintenanceCreate_IsAccessible()) {
        MasterService.createRoyaltyClient(
          royaltyClientData,
          this.saveRoyaltyClientResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  editRoyaltyClientResponse = (response) => {
    if (response.data != null) {
      if (!isEmptyArray(response.data.royaltyClientBean)) {
        let royaltyClientData = new RoyaltyClientBean();
        royaltyClientData = response.data.royaltyClientBean;
        if (royaltyClientData.address != null) {
          this.setState({
            addressData: royaltyClientData.address,
          });
        }
        this.setState({
          royaltyClientData: royaltyClientData,
        });
        this.disable();
      }
    }
    this.openRoyaltyClientEntryForm();
  };
  editRoyaltyClient = (royaltyClientCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = royaltyClientCode;
    if (SecurityAccessManager.RoyaltyClientMaintenanceView_IsAccessible()) {
      MasterService.readRoyaltyClient(
        readrestInput,
        this.editRoyaltyClientResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let temp_royaltyClientdata = this.state.royaltyClientData;
    temp_royaltyClientdata[e.target.name] = e.target.value;
    this.setState({
      royaltyClientData: temp_royaltyClientdata,
    });
  };
  onAddressChange = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData[e.target.name] = e.target.value;
    this.setState({ addressData: temp_addressData });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let royaltyClientData = this.state.royaltyClientData;
    royaltyClientData.companyCode = this.companyCode;
    royaltyClientData.code = this.state.royaltyClientData.code.toUpperCase();
    royaltyClientData.address = this.state.addressData;
    this.clearError();
    this.saveRoyaltyClient(royaltyClientData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeRoyaltyClientEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openRoyaltyClientEntryForm = () => {
    this.setState({
      isRoyaltyClientListFormOpen: false,
      isRoyaltyClientEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeRoyaltyClientEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isRoyaltyClientListFormOpen: true,
      isRoyaltyClientEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadRoyaltyClientResponse = (response) => {
    if (response.data != null && response.data.royaltyClientPageList != null) {
      let royaltyClientList = new Array();
      if (!isEmptyArray(response.data.royaltyClientPageList.royaltyClients)) {
        royaltyClientList = response.data.royaltyClientPageList.royaltyClients;
        royaltyClientList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.royaltyClientPageList.currentPage;
      pageList.pageSize = response.data.royaltyClientPageList.pageSize;
      pageList.totalCount = response.data.royaltyClientPageList.totalCount;
      this.setState({
        royaltyClient_list: royaltyClientList,
        pageList: pageList,
      });
    }
    // if (response.data != null) {
    //   const royaltyClient_list =
    //     response.data.royaltyClientPageList.royaltyClients;
    //   royaltyClient_list.map((Info) => {
    //     if (Info.isActive == true) {
    //       Info.isActive = "True";
    //     } else {
    //       Info.isActive = "False";
    //     }
    //   });
    //   let pageList = this.state.pageList;

    //   pageList.totalCount = response.data.royaltyClientPageList.totalCount;
    //   pageList.currentPage = response.data.royaltyClientPageList.currentPage;
    //   if (royaltyClient_list == null) {
    //     royaltyClient_list = new Array();
    //   }
    //   this.setState({
    //     royaltyClient_list: royaltyClient_list,
    //     pageList: pageList,
    //   });
    // } else {
    //   this.handleresponse(response.data);
    // }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new RoyaltyClientSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadRoyaltyClientPage(pageInput, criteria);
  };
  loadRoyaltyClientPage = (pageList, searchCriteria) => {
    let criteria = new RoyaltyClientSearchCriteria();
    criteria = searchCriteria;
    let requestInput = new RestRoyaltyClientListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.RoyaltyClientMaintenanceView_IsAccessible()) {
      MasterService.getRoyaltyClientPageList(
        requestInput,
        this.loadRoyaltyClientResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  buttonCancelClickCallback = () => {
    let empArray = [];
    let errorMessage = "Access Denied";
    empArray.push(errorMessage);
    this.setState({
      alertMessage: empArray,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  deleteRoyaltyClient = (rowData) => {
    let criteria = new RoyaltyClientSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = rowData;
    if (SecurityAccessManager.RoyaltyClientMaintenanceDelete_IsAccessible()) {
      MasterService.deleteRoyaltyClient(
        criteria,
        this.deleteRoyaltyClientResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Delete Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteRoyaltyClientResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let addressData = this.state.addressData;
    let country = e.target.value;

    addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let addressData = this.state.addressData;
      addressData.country = countryBean.code;

      this.setState({
        addressData: addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };

  //city

  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.addressData;
      temp_addressData.city = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let city = e.target.value;

    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  //state
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.addressData;
      temp_addressData.state = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.royaltyClient_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ royaltyClient_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isRoyaltyClientListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isRoyaltyClientListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isRoyaltyClientListFormOpen && (
          <RoyaltyClientListForm
            royaltyClient_list={this.state.royaltyClient_list}
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            clickGoButton={this.clickGoButton}
            royaltyClientData={this.state.royaltyClientData}
            editRoyaltyClient={this.editRoyaltyClient}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            deleteRoyaltyClient={this.deleteRoyaltyClient}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isRoyaltyClientListFormOpen && (
          <RoyaltyClientEntryForm
            {...this.state}
            royaltyClientData={this.state.royaltyClientData}
            addressData={this.state.addressData}
            closeRoyaltyClientEntryForm={this.closeRoyaltyClientEntryForm}
            saveRoyaltyClient={this.saveRoyaltyClient}
            editRoyaltyClient={this.editRoyaltyClient}
            onChange={this.onChange}
            onAddressChange={this.onAddressChange}
            onCountryChange={this.onCountryChange}
            countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
            displayAutoCompleteCountryCodeList={
              this.displayAutoCompleteCountryCodeList
            }
            onCityChange={this.onCityChange}
            cityEnterKeyEvent={this.cityEnterKeyEvent}
            displayAutoCompleteCityList={this.displayAutoCompleteCityList}
            onStateChange={this.onStateChange}
            stateEnterKeyEvent={this.stateEnterKeyEvent}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          />
        )}
      </div>
    );
  }
}

function RoyaltyClientAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <RoyaltyClientList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default RoyaltyClientAttributeModule;
